import { FC, lazy, Suspense, useMemo } from 'react';

import CopyToClipboard from './CopyToClipboard';
import { CodeProps } from './Editor/Code';

const Code = lazy(() => import('./Editor/Code'));

interface Props extends CodeProps {
  copyToClipboard?: boolean;
  multiLine?: boolean;
}

const CodeEditor: FC<Props> = ({ value, copyToClipboard, multiLine = false, ...restProps }) => {
  const toolbar = useMemo(() => {
    return copyToClipboard ? (
      <CopyToClipboard variant="ghost" round text="" value={value} multiLine={multiLine} />
    ) : null;
  }, [copyToClipboard, multiLine, value]);

  return (
    <Suspense fallback="">
      <Code theme="dark" toolbar={toolbar} value={value} {...restProps} />
    </Suspense>
  );
};

export default CodeEditor;
